/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Ten_FramesInputs */



/**
* | output |
* | --- |
* | "Go back ten frames in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Ten_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_ten_frames = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Ten_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Ten_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de dix images dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spulen Sie im Video zehn Frames zurück.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna indietro di dieci fotogrammi nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернитесь на десять кадров назад в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceda diez fotogramas en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频倒退十帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを10フレーム前に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में दस फ्रेम पीछे जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volte dez frames no vídeo.")
	return /** @type {LocalizedString} */ ("Go back ten frames in the video")
});